import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { VideoGenerationProvider } from './contexts/VideoGenerationContext';
import VideoGenerationModal from './components/VideoGenerationModal';
import LoginPage from './LoginPage';
import ProjectListPage from './ProjectListPage';
import VideoEditorPage from './VideoEditorPage';
import VideoCanvasPage from './VideoCanvasPage';
import FrameEditorPage from './FrameEditorPage';
import ClipEditorPage from './ClipEditorPage';
import ProjectVideosPage from './ProjectVideosPage';
import TutorialPage from './TutorialPage';
import QuickPreviewPage from './QuickPreviewPage';
import YouTubeDetailsPage from './YouTubeDetailsPage';
import YouTubeLinkingPage from './YouTubeLinkingPage';
import DeployPage from './DeployPage';
import PublishedVideosPage from './PublishedVideosPage';
import LearningPage from './LearningPage';
import './App.css'; // Import your global CSS

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check if user is already authenticated on app load
  useEffect(() => {
    const authStatus = localStorage.getItem('isAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', 'true');
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('isAuthenticated');
  };

  // If not authenticated, show login page
  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} />;
  }

  // If authenticated, show the main app
  return (
    <VideoGenerationProvider>
      <Router>
        <Routes>
          <Route path="/" element={<ProjectListPage onLogout={handleLogout} />} />
          <Route path="/youtube-linking" element={<YouTubeLinkingPage />} />
          <Route path="/project/:projectId" element={<VideoEditorPage />} />
          <Route path="/project/:projectId/canvas" element={<VideoCanvasPage />} />
          <Route path="/project/:projectId/frame-editor/:itemId" element={<FrameEditorPage />} />
          <Route path="/project/:projectId/clip-editor/:itemId" element={<ClipEditorPage />} />
          <Route path="/project/:projectId/videos" element={<ProjectVideosPage />} />
          <Route path="/project/:projectId/tutorial" element={<TutorialPage />} />
          <Route path="/project/:projectId/quick-preview" element={<QuickPreviewPage />} />
          <Route path="/project/:projectId/quick-preview/:itemId" element={<QuickPreviewPage />} />
          <Route path="/project/:projectId/deploy" element={<DeployPage />} />
          <Route path="/project/:projectId/published-videos" element={<PublishedVideosPage />} />
          <Route path="/project/:projectId/youtube" element={<YouTubeDetailsPage />} />
          <Route path="/project/:projectId/learning" element={<LearningPage />} />
          <Route path="/master-project/:masterProjectId/learning" element={<LearningPage />} />
        </Routes>
        <VideoGenerationModal />
      </Router>
    </VideoGenerationProvider>
  );
}

export default App;